import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getLanguagesRedux = createAsyncThunk(
    "language/getLanguage",
    async (lang) => {
        const response = await axios.post(
            `${baseURL}/api/user/language/`,
            `language=${lang}`,
            RequestConfig(),
        );
        return response.data;
    },
);
